import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * "Back" that never leaves the site: goes back in history when the person came from another
 * Procedures page, otherwise to `fallback` (the directory by default). People often arrive straight
 * from a QR code, so there may be no history at all.
 */
export function useSafeBack(fallback = '/'): () => void {
  const navigate = useNavigate();
  return useCallback(() => {
    let idx = 0;
    try {
      idx = (window.history.state as { idx?: number } | null)?.idx ?? 0;
    } catch {
      idx = 0;
    }
    if (idx > 0) navigate(-1);
    else navigate(fallback, { replace: true });
  }, [navigate, fallback]);
}
